import React from 'react'
import './About.css'
import fabian from '../../assets/img/avatar-fabian-about.png'
import countProjets from '../../assets/img/count-projets.svg'
import countClients from '../../assets/img/count-clients.svg'
import countExperience from '../../assets/img/count-experience.svg'
import { useTranslation } from 'react-i18next'

const About = () => {
  const { t } = useTranslation();
  
  return (
    <section id='about' className="content_section">
      <div className="content_section_inner">
        <h2>{t('about.title')}</h2>
        <div className='container'>
          <div className='col col-1-3'>
            <img src={fabian} alt="" className='about-avatar' />
          </div>
          <div className='col col-2-3'>
            <h3>{t('about.subtitle')}</h3>
            <p>{t('about.description1')}</p>
            <p>{t('about.description2')}</p>
            <p>{t('about.description3')}</p>

          </div>

          <div className='col col-1'>
            <div className='count-item'>
              <img src={countProjets} alt="" />
              <div className='count-item-inner'>
                <h3>147</h3>
                <p>{t('about.stats.projects')}</p>
              </div>
            </div>
          </div>

          <div className='col col-1'>
          <div className='count-item'>
              <img src={countExperience} alt="" />
              <div className='count-item-inner'>
                <h3>16</h3>
                <p>{t('about.stats.experience')}</p>
              </div>
            </div>
          </div>

          <div className='col col-1'>
          <div className='count-item'>
              <img src={countClients} alt="" />
              <div className='count-item-inner'>
                <h3>27</h3>
                <p>{t('about.stats.clients')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
} 

export default About